import { useSearchParams } from "react-router";
import {
  ERZEUGER_EXPRESS_TABS,
  isExpressOnboardingTab
} from "../ExpressOnboardingModal";

const ERZEUGER_EXPRESS_SEARCH_PARAM = "ExpressOnboarding";

function useExpressOnboardingModal() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get(ERZEUGER_EXPRESS_SEARCH_PARAM);
  const isOpen = tabParam !== null;
  const tab = isExpressOnboardingTab(tabParam)
    ? tabParam
    : ERZEUGER_EXPRESS_TABS.GENERAL;

  const openSearchParams = new URLSearchParams(searchParams);
  openSearchParams.set(
    ERZEUGER_EXPRESS_SEARCH_PARAM,
    ERZEUGER_EXPRESS_TABS.GENERAL
  );

  function setTab(newTab: string | null) {
    if (!isExpressOnboardingTab(newTab)) {
      return;
    }

    setSearchParams(
      (prev) => {
        prev.set(ERZEUGER_EXPRESS_SEARCH_PARAM, newTab);
        return prev;
      },
      { replace: true }
    );
  }

  function close() {
    setSearchParams(
      (prev) => {
        prev.delete(ERZEUGER_EXPRESS_SEARCH_PARAM);
        return prev;
      },
      { replace: true }
    );
  }
  return {
    isOpen,
    tab,
    openSearchParams,
    setTab,
    close
  };
}

export { useExpressOnboardingModal };
